import type { FileType } from '../types';

/**
 * Demo video shown to new users with empty libraries
 * This is a hardcoded video that serves as an onboarding tutorial
 */
export const DEMO_VIDEO_ID = 'demo-video-onboarding';

export const DEMO_VIDEO: FileType = {
  // Core identification
  _id: DEMO_VIDEO_ID,
  id: DEMO_VIDEO_ID,
  type: 'File',

  // Display information
  name: 'ScreenApp Demo',
  description: '',

  // Video metadata
  duration: 60, // 1 minute
  thumbUrl: 'https://screenapp.io/assets/static/videoposter.webp',
  url: 'https://screenapp.io/screenapp-resources/upgrade-view/videos/v1/1minutedemo.mp4',

  // Storage metadata
  size: 5242880, // 5MB in bytes
  providerKey: 'demo-video-key',
  provider: 'static' as const,
  streams: ['video', 'audio'],
  defaultProfile: 'mp4' as const,

  // Owner information (ScreenApp official)
  ownerId: 'screenapp-official',
  owner: {
    name: 'ScreenApp',
    picture:
      "data:image/svg+xml,%3csvg%20width='1024'%20height='1024'%20viewBox='0%200%201024%201024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='1024'%20height='1024'%20rx='205'%20fill='%235194FF'/%3e%3cpath%20d='M471.58%20418.411V677.97C471.58%20699.764%20489.814%20717.42%20512.339%20717.42C534.864%20717.42%20553.135%20699.764%20553.135%20677.97V418.411C553.135%20396.619%20534.864%20378.961%20512.339%20378.961C489.814%20378.961%20471.58%20396.619%20471.58%20418.411Z'%20fill='white'/%3e%3cpath%20d='M604.121%20375.973V585.641C604.121%20607.418%20622.355%20625.075%20644.898%20625.075C667.422%20625.075%20685.675%20607.418%20685.675%20585.641V375.973C685.675%20354.197%20667.422%20336.525%20644.898%20336.525C622.355%20336.525%20604.121%20354.197%20604.121%20375.973Z'%20fill='white'/%3e%3cpath%20d='M338.997%20346.017V594.574C338.997%20616.368%20357.272%20634.024%20379.791%20634.024C402.312%20634.024%20420.594%20616.368%20420.594%20594.574V346.017C420.594%20324.239%20402.312%20306.581%20379.791%20306.581C357.272%20306.581%20338.997%20324.239%20338.997%20346.017Z'%20fill='white'/%3e%3cpath%20d='M206.451%20494.956V518.619C206.451%20540.397%20224.711%20558.039%20247.247%20558.039C269.751%20558.039%20288.01%20540.397%20288.01%20518.619V494.956C288.01%20473.164%20269.751%20455.506%20247.247%20455.506C224.711%20455.506%20206.451%20473.164%20206.451%20494.956Z'%20fill='white'/%3e%3cpath%20d='M735.625%20498.774V518.619C735.625%20540.397%20753.896%20558.038%20776.421%20558.038C798.945%20558.038%20817.217%20540.397%20817.217%20518.619V498.774C817.217%20476.982%20798.945%20459.324%20776.421%20459.324C753.896%20459.324%20735.625%20476.982%20735.625%20498.774Z'%20fill='white'/%3e%3c/svg%3e",
  },
  recorderEmail: 'hello@screenapp.io',
  recorderName: 'ScreenApp',

  // Team/Space (will be populated with actual values)
  teamId: '',
  spaceId: '',

  // Timestamps
  createdAt: new Date(),
  updatedAt: new Date(),

  // Folder location (recents)
  parentId: 'recents',

  // Demo video has basic transcript data for demonstration
  textData: {
    transcriptRequestedAt: new Date('2024-01-01').toISOString(),
    transcriptCompletedAt: new Date().toISOString(),
    transcriptUrl: 'demo-transcript-available',
    transcriptProviderKey: 'demo-transcript',
    speakers: {
      '0': {
        name: 'Andre',
        picture:
          "data:image/svg+xml,%3csvg%20width='1024'%20height='1024'%20viewBox='0%200%201024%201024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='1024'%20height='1024'%20rx='205'%20fill='%235194FF'/%3e%3cpath%20d='M471.58%20418.411V677.97C471.58%20699.764%20489.814%20717.42%20512.339%20717.42C534.864%20717.42%20553.135%20699.764%20553.135%20677.97V418.411C553.135%20396.619%20534.864%20378.961%20512.339%20378.961C489.814%20378.961%20471.58%20396.619%20471.58%20418.411Z'%20fill='white'/%3e%3cpath%20d='M604.121%20375.973V585.641C604.121%20607.418%20622.355%20625.075%20644.898%20625.075C667.422%20625.075%20685.675%20607.418%20685.675%20585.641V375.973C685.675%20354.197%20667.422%20336.525%20644.898%20336.525C622.355%20336.525%20604.121%20354.197%20604.121%20375.973Z'%20fill='white'/%3e%3cpath%20d='M338.997%20346.017V594.574C338.997%20616.368%20357.272%20634.024%20379.791%20634.024C402.312%20634.024%20420.594%20616.368%20420.594%20594.574V346.017C420.594%20324.239%20402.312%20306.581%20379.791%20306.581C357.272%20306.581%20338.997%20324.239%20338.997%20346.017Z'%20fill='white'/%3e%3cpath%20d='M206.451%20494.956V518.619C206.451%20540.397%20224.711%20558.039%20247.247%20558.039C269.751%20558.039%20288.01%20540.397%20288.01%20518.619V494.956C288.01%20473.164%20269.751%20455.506%20247.247%20455.506C224.711%20455.506%20206.451%20473.164%20206.451%20494.956Z'%20fill='white'/%3e%3cpath%20d='M735.625%20498.774V518.619C735.625%20540.397%20753.896%20558.038%20776.421%20558.038C798.945%20558.038%20817.217%20540.397%20817.217%20518.619V498.774C817.217%20476.982%20798.945%20459.324%20776.421%20459.324C753.896%20459.324%20735.625%20476.982%20735.625%20498.774Z'%20fill='white'/%3e%3c/svg%3e",
        email: '',
        userId: 'andre-demo',
      },
    },
  },

  // No sharing for demo video
  share: undefined,

  // Tags to identify this as a demo
  tags: {
    'is-demo': 'true',
    'demo-version': '1.0',
  },
};

/**
 * Check if a file ID is the demo video
 */
export const isDemoVideo = (fileId: string): boolean => {
  return fileId === DEMO_VIDEO_ID;
};

/**
 * Check if user should see demo video based on library state
 * Demo video is shown when:
 * 1. User has no files in their library
 * 2. User hasn't uploaded any files before (no 'first-upload' tag)
 */
export const shouldShowDemoVideo = (
  fileCount: number,
  userHasUploadedBefore: boolean,
): boolean => {
  return fileCount === 0 && !userHasUploadedBefore;
};
